import React from 'react';
import { Divider } from 'semantic-ui-react';

export const Spacer = () => <Divider hidden />;
